import { useSelector } from 'APP/Hooks/redux'
import Config from 'APP/Config'
import I18n from 'APP/I18n'
import { selectPharmacies } from 'APP/Store/Pharmacies/selectors'
import { useNavigation } from '@react-navigation/native'
import { LimitedPharmacy, Pharmacy } from '@dialogue/coredata'
import type { Immutable } from 'seamless-immutable'
import type { NormalizedEpharmacy } from 'APP/Store/Patient/types'

export const getPharmacyProvince = (pharmacy: Pharmacy | LimitedPharmacy | null | undefined) => {
  return pharmacy?.admin_area_level_1_iso_code?.toLowerCase()
}

/**
 * Navigates to the Pillway portal screen with the appropriate URL
 * @param {Object} navigation - The navigation object from useNavigation()
 * @param {Object} pharmacy - The pharmacy object from selectEpharmacyExternalServicesByProvider()
 * @param {Array} pharmacies - The list of pharmacies from selectPharmacies()
 * @param {String} [subRoute] - Optional sub-route to append to the Pillway URL.
 */
export const navigateToPillwayPortal = (
  // @ts-expect-error TODO: type navigation object here
  navigation,
  pharmacy: NormalizedEpharmacy | null,
  pharmacies: LimitedPharmacy[] | null,
  subRoute: string | null = null
) => {
  if (!navigation) return
  if (!pharmacy || !pharmacies) return

  // Fetch province of epharmacy health resource from pharmacy list
  // This is the province where the ePharmacy is physically located.
  const province =
    getPharmacyProvince(
      pharmacies?.find((p) => p.external_id === pharmacy.attributes?.epharmacyIdentifier)
    ) || ''

  // Generate full Pillway URL
  subRoute = subRoute || 'account'
  const url = `${Config.PILLWAY_DOMAIN}/#/${subRoute}?lang=${I18n.locale}&loc=${province}`

  // Navigate to Pillway webview
  navigation.navigate('pillwayPortalScreen', {
    navigationUrl: url,
  })
}

export const usePillwayNavigation = () => {
  const navigation = useNavigation()
  const pharmacies = useSelector(selectPharmacies)

  return (
    pharmacy: Immutable<NormalizedEpharmacy> | NormalizedEpharmacy | null,
    subRoute?: string | null
  ) => {
    // @ts-expect-error Pharmacy and LimitedPharmacy don't have compatible type property
    navigateToPillwayPortal(navigation, pharmacy, pharmacies, subRoute)
  }
}
